type BoxboatColorType = {
  primary: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
  };
  gray: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    1000: string;
    1100: string;
  };
  teal: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
  };
  yellow: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
  };
  green: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
  };
};

export const boxboatColors: BoxboatColorType = {
  primary: {
    100: '#ffffff',  // Carbon White
    200: '#f4f4f4',  // Carbon Gray 10
    300: '#e0e0e0',  // Carbon Gray 20
    400: '#161616',  // Carbon Gray 100
    500: '#262626',  // Carbon Gray 90
    600: '#393939',  // Carbon Gray 80
    700: '#000000',  // Pure black
    800: '#ffffff',  // White background
  },
  gray: {
    100: '#f4f4f4',  // Carbon Gray 10
    200: '#e0e0e0',  // Carbon Gray 20
    300: '#c6c6c6',  // Carbon Gray 30
    400: '#a8a8a8',  // Carbon Gray 40
    500: '#8d8d8d',  // Carbon Gray 50
    600: '#6f6f6f',  // Carbon Gray 60
    700: '#525252',  // Carbon Gray 70
    800: '#393939',  // Carbon Gray 80
    900: '#262626',  // Carbon Gray 90
    1000: '#161616', // Carbon Gray 100
    1100: '#f4f4f4', // Carbon Gray 10
  },
  teal: {
    100: '#ffffff',
    200: '#f4f4f4',
    300: '#e0e0e0',
    400: '#161616',
    500: '#262626',
    600: '#393939',
    700: '#000000',
  },
  yellow: {
    100: '#ffffff',
    200: '#f4f4f4',
    300: '#e0e0e0',
    400: '#161616',
    500: '#262626',
    600: '#393939',
    700: '#000000',
  },
  green: {
    100: '#ffffff',
    200: '#f4f4f4',
    300: '#e0e0e0',
    400: '#161616',
    500: '#262626',
    600: '#393939',
    700: '#000000',
  },
};
